<template>
  <div>
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true">
        <el-form-item label="日期范围：">
          <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" range-separator="至" unlink-panels size="medium" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-input v-model="searchForm.PRODUCT_CODE" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME" size="medium"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="queryData()">筛选</el-button>
          <el-button size="medium" @click="exportTable()">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table border stripe :data="tableData">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="需出库数量"></el-table-column>
        <el-table-column prop="WAREHOUSE_COUNT" label="库存数量"></el-table-column>
        <el-table-column prop="DIFFERENCE" label="拟出库剩余库存"></el-table-column>
      </el-table>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <download-excel style="z-index:-2;position:absolute;" id="download_excel" :data="excelpage" :fields="json_fields" :name="filename">
      <el-button> 导出 </el-button>
    </download-excel>
  </div>
</template>

<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        DAY_INTERVAL: [],
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      filename: '',
      excelpage: [], // 存放用于导出excel的数据
      json_fields: {
        产品编码: 'PRODUCT_CODE', // 常规字段
        产品名称: 'PRODUCT_NAME', // 支持嵌套属性
        单位: 'TYPE_UNIT',
        需出库数量: 'PRODUCT_COUNT',
        库存数量: 'WAREHOUSE_COUNT',
        拟出库剩余库存: 'DIFFERENCE',
      },
      json_meta: [
        [
          {
            ' key ': ' charset ',
            ' value ': ' utf- 8 ',
          },
        ],
      ],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.initDate();
    this.queryData();
  },
  methods: {
    exportTable() {
      if (!this.searchForm.DAY_INTERVAL) {
        this.$message.show({ text: '请选择时间范围', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 105,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        START_DATE: this.searchForm.DAY_INTERVAL[0],
        END_DATE: this.searchForm.DAY_INTERVAL[1],
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      this.loading = true;
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.excelpage = result;
          this.filename = `拟出库情况表${this.searchForm.DAY_INTERVAL[0]}至${this.searchForm.DAY_INTERVAL[1]}.xls`;
          document.getElementById('download_excel').click();
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      if (!this.searchForm.DAY_INTERVAL) {
        this.$message.show({ text: '请选择时间范围', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 104,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        START_DATE: this.searchForm.DAY_INTERVAL[0],
        END_DATE: this.searchForm.DAY_INTERVAL[1],
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      this.loading = true;
      http.post(params).then((result) => {
        if (result[0].LIST.length !== 0) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    initDate() {
      this.searchForm.DAY_INTERVAL.push(date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), '%F'));
      this.searchForm.DAY_INTERVAL.push(date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), '%F'));
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};

</script>

<style></style>



// WEBPACK FOOTER //
// src/components/warehouseManage/plannedOutbound.vue